export default "__VITE_ASSET__879124da__"